import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";

interface IColumnProps {
  graphOptions: {
    options?: {
      chart?: {
        width?: number;
        height?: number;
      };
    };
    series?: Array<unknown>;
  };
  dataTestId?: string;
}

const Column: FunctionComponent<IColumnProps> = ({
  graphOptions,
  dataTestId,
}) => {
  const { options, series } = graphOptions;

  return (
    <div data-test-id={dataTestId} className="chart-item">
      <Chart
        options={options}
        series={series}
        type="bar"
        width={options.chart.width}
        height={options.chart.height}
      />
    </div>
  );
};

Column.propTypes = {
  graphOptions: PropTypes.shape({
    options: PropTypes.shape({
      chart: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    }),
    series: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  dataTestId: PropTypes.string,
};

Column.defaultProps = {
  dataTestId: null,
};

export default Column;
